/**
 * Phase 2b — Left-rail nav for /docs.
 * Built from /api/wiki/nav. Active leaf gets the cyan glowing-node + hairline
 * "block-on-chain" indicator from the design blueprint.
 *
 * Phase 12.2b — Each section title now renders in its own brand accent
 * color with a hairline underline. The color comes from the shared
 * `sectionStyles` map so it matches the DocsLanding tiles, future
 * article H1s, etc. The underline + colored title makes "where am I
 * in the docs" visible at a glance even on a long nav.
 */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { styleForSection } from "../../lib/sectionStyles";


function leafTestId(slug) {
  return `docs-left-nav-${(slug || "").replace(/\//g, "-")}`;
}


export default function LeftRailNav({ nodes, currentSlug }) {
  if (!nodes || nodes.length === 0) {
    return (
      <nav className="qt-docs-leftnav" aria-label="Docs sections">
        <p
          className="font-mono text-xs"
          style={{ color: "#4B5B76", padding: "1rem 0" }}
        >
          No sections published yet.
        </p>
      </nav>
    );
  }

  return (
    <nav
      className="qt-docs-leftnav"
      aria-label="Docs sections"
      data-testid="docs-left-nav"
    >
      {nodes.map((section, i) => {
        const sectionActive = (section.children || []).some(
          (leaf) => leaf.slug === currentSlug,
        );
        const { color } = styleForSection(section.title);
        return (
        <div key={`${section.title}-${i}`} className="mb-6">
          <div
            className={`qt-docs-section-title ${sectionActive ? "is-active-section" : ""}`}
            style={{
              "--section-accent": color,
              color,
            }}
            data-testid={`docs-leftnav-section-${i}`}
          >
            {section.title}
          </div>
          <ul className="space-y-0.5">
            {(section.children || []).map((leaf) => {
              const isActive = leaf.slug === currentSlug;
              return (
                <li key={leaf.slug} className="relative">
                  <Link
                    to={`/docs/${leaf.slug}`}
                    data-testid={leafTestId(leaf.slug)}
                    className={`qt-docs-leftnav-leaf ${isActive ? "is-active" : ""}`}
                  >
                    {isActive && <span className="qt-docs-leftnav-node" aria-hidden="true" />}
                    {leaf.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
        );
      })}
    </nav>
  );
}
